export const VALUES_FIELD_NAME = [
    'Image',
    'Audio',
    'Video',
    'Text file',
    'HTML file',
    'Rubaway',
] as const;
export type TYPES_FIELD_NAME = typeof VALUES_FIELD_NAME[number];

export const VALUES_FIELD_ID = [1, 2, 3, 4, 5, 6] as const;
export type TYPES_FIELD_ID = typeof VALUES_FIELD_ID[number];

export const VALUES_FIELD_DEFAULTEXTENSIONS = [
    '.png, .jpg, .jpeg',
    '.mp3, .aac',
    '.mp4',
    '.txt, .md',
    '.html, .zip',
    // Null,
];
export type TYPES_FIELD_DEFAULTEXTENSIONS = typeof VALUES_FIELD_DEFAULTEXTENSIONS[number];
